// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Qx8v","pickupWrapper":"styles_pickupWrapper__2B9jF","separator":"styles_separator__2tG_C"};